var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return false ? _c('div', {
    staticClass: "box-left-link-wrap",
    staticStyle: {
      "margin-top": "38px"
    }
  }, [_c('p', {
    staticClass: "box-left-title"
  }, [_vm._v(_vm._s(_vm.$t("explConapp")))]), _vm._v(" "), _vm._m(0)]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-left-link"
  }, [_c('a', {
    staticClass: "back1",
    attrs: {
      "target": "_blank",
      "href": "//go.onelink.me/app/iostrending"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "androidlink",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "target": "_blank",
      "href": "/app/download/apk/liveme_4.2.32_release.apk"
    }
  })]);
}];
export { render, staticRenderFns };